import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/client";
import { FILTERS_TARIFFS_ADDRESS_QUERY, PROVIDERS_V3_BY_STREET } from "Services/queries";
import { RandomMobileTariffListContainer } from "Containers/Tariffs";
import { ContainerPaddingBottom } from "ComponentsUI/Spacings";

const RandomMobileTariffListHOC = (props) => {
	const { tariffsLocation, house_id, textHeader, seoBlock } = props;
	const { streetId } = useParams();

	const { data: providersHouse, loading: loadingProvidersHouse } = useQuery(
		FILTERS_TARIFFS_ADDRESS_QUERY,
		{
			skip: tariffsLocation !== "house" || !house_id,
			variables: {
				houseId: house_id,
			},
		}
	);
	const { data: providersStreet, loading: loadingProvidersStreet } = useQuery(
		PROVIDERS_V3_BY_STREET,
		{
			skip: tariffsLocation !== "street" || !streetId,
			variables: {
				street_id: +streetId,
				sort: "-vip_provider,vip_b2c_priority,-rating.expert.final,name",
				random: false,
			},
		}
	);

	let countProviders = useMemo(() => {
		if (loadingProvidersHouse || loadingProvidersStreet) {
			return undefined;
		} else if (providersHouse) {
			return providersHouse?.filtersTariffsAddress?.providers.length;
		} else if (providersStreet) {
			return providersStreet?.providersV3?.data?.length;
		}
	}, [providersHouse, providersStreet, loadingProvidersHouse, loadingProvidersStreet]);

	if (countProviders === undefined || countProviders > 2) {
		return null;
	}

	return (
		<ContainerPaddingBottom>
			<RandomMobileTariffListContainer textHeader={textHeader} seoBlock={seoBlock} />
		</ContainerPaddingBottom>
	);
};

RandomMobileTariffListHOC.propTypes = {
	tariffsLocation: PropTypes.string.isRequired,
	house_id: PropTypes.number,
	textHeader: PropTypes.string.isRequired,
};

export default RandomMobileTariffListHOC;
